import { render, staticRenderFns } from "./BuyersMap.vue?vue&type=template&id=6a0bf9fa&scoped=true&"
import script from "./BuyersMap.vue?vue&type=script&lang=js&"
export * from "./BuyersMap.vue?vue&type=script&lang=js&"
import style0 from "./BuyersMap.vue?vue&type=style&index=0&id=6a0bf9fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0bf9fa",
  null
  
)

export default component.exports